import { render, staticRenderFns } from "./swiperImgTxt.vue?vue&type=template&id=c54d308a&scoped=true&"
import script from "./swiperImgTxt.vue?vue&type=script&lang=js&"
export * from "./swiperImgTxt.vue?vue&type=script&lang=js&"
import style0 from "./swiperImgTxt.vue?vue&type=style&index=0&id=c54d308a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54d308a",
  null
  
)

export default component.exports